export const CONFIG = {
    URL: 'https://virtualproxykeep.com',
    NAME: 'VirtualProxyKeeper',
    MAIL: 'proxykeeper.help@gmail.com'
}